import {
  AXIOS_AUTHED,
  AXIOS_UNAUTHED,
  DEFAULT_PAGEABLE,
  getApiUrl,
  getPublicApiUrl
} from './shared';
import { constructPageString } from '../../utils/api-util';
import { serializeAsQueryString } from '../../utils/utils';

const RENEWALS_BASE_URL = `${getApiUrl()}/renewals`;
const RENEWALS_PUBLIC_URL = `${getPublicApiUrl()}/renewals`;

const DEFAULT_SEARCH = {
    statuses: null,
    renewalIds: null,
    customerIds: null,
    startDate: null,
    endDate: null
};

const get = (renewalId) => {
    return AXIOS_AUTHED.get(`${RENEWALS_BASE_URL}/${renewalId}`);
};

const search = (pageable = DEFAULT_PAGEABLE, criteria = DEFAULT_SEARCH) => {
    const pageString = constructPageString(pageable);
    const queryString = buildQueryString(criteria);
    return AXIOS_AUTHED.get(`${RENEWALS_BASE_URL}?${pageString}&${queryString}`);
};

const getBySecret = (secret) => {
    return AXIOS_UNAUTHED.get(`${RENEWALS_PUBLIC_URL}/${secret}`);
};

const startByBrc = (brc) => {
    return AXIOS_AUTHED.post(`${RENEWALS_BASE_URL}/customer`, brc, {
        headers: {
            'content-type': 'text/plain'
        }
    });
};

const submit = (renewalId, workFlowAction) => {
    return AXIOS_AUTHED.post(`${RENEWALS_BASE_URL}/workflow-request`, {
        renewalId,
        action: workFlowAction.name
    });
};

const update = (renewal) => {
    return AXIOS_AUTHED.put(RENEWALS_BASE_URL, renewal);
};

const signBySecret = (secret, fields) => {
    return AXIOS_UNAUTHED.patch(`${RENEWALS_PUBLIC_URL}/${secret}`, fields);
};

const validate = (renewal) => {
    return AXIOS_AUTHED.post(`${RENEWALS_BASE_URL}/validate`, renewal);
};

const validateLineItem = (renewalLineItem) => {
    return AXIOS_AUTHED.post(
        `${getApiUrl()}/renewal-line-items/validate`,
        renewalLineItem
    );
};

const buildQueryString = (criteria) => {
    return serializeAsQueryString(criteria, true);
};

const resendCompletedRequest = (renewalId) => {
    return AXIOS_AUTHED.post(`${RENEWALS_BASE_URL}/resend-completed`, {
        renewalId,
        workflowTicket: null,
        emailAddress: null,
        branchCode: null
    });
};

const resendSignatureEmailRequest = (renewalId) => {
    return AXIOS_AUTHED.post(`${RENEWALS_BASE_URL}/resend-signature`, {
        renewalId,
        workflowTicket: null
    });
};

const getRenewalSummary = (renewalId) => {
    return AXIOS_AUTHED.get(
        `${RENEWALS_PUBLIC_URL}/${renewalId}/contract-summary`,
        {
            responseType: 'arraybuffer'
        }
    );
};

const getRenewalProposal = (renewalId) => {
    return AXIOS_AUTHED.get(
        `${RENEWALS_BASE_URL}/${renewalId}/contract-proposal`,
        {
            responseType: 'arraybuffer'
        }
    );
};

const contract = (renewalId, agreementType) => {
    return getAxiosInstanceByLoginMode().get(
        `${RENEWALS_BASE_URL}/${renewalId}/contract/${agreementType}`,
        {
            responseType: 'arraybuffer'
        }
    );
};

export {
    get,
    search,
    getBySecret,
    startByBrc,
    submit,
    update,
    signBySecret,
    validate,
    validateLineItem,
    resendCompletedRequest,
    getRenewalSummary,
    resendSignatureEmailRequest,
    getRenewalProposal
};
